export const ADD_TO_USER_CART = "ADD_TO_USER_CART"
export const REMOVE_ITEM = "REMOVE_ITEM"
export const SUB_QUANTITY = "SUB_QUANTITY"
export const ADD_QUANTITY  = "ADD_QUANTITY "
export const ADD_SHIPPING  = "ADD_SHIPPING"
export const SUB_SHIPPING = "SUB_SHIPPING"